import { useState } from "react";
import MessageActions from "../../MessageActions";
import markdownIt from 'markdown-it';
import mila from "markdown-it-link-attributes";
import ParentChatMessage from "../../ParentChatMessage";
import { adjustHexColor } from "../../../services/shared";
import { useSelector } from "react-redux";

let md = markdownIt({ html: false, linkify: true, typographer: true, breaks: false });
md.use(mila, { attrs: { target: "_blank", rel: "noopener", } });

export const Image = (props: any) => {
	const { message, topMargin } = props;
	const [isHover, setIsHover] = useState(false);
	const design = useSelector((state: any) => state?.design);
	return (
		<>
			<div
				className={`ele-image image-container relative inline-block rounded-xl py-2 px-4 max-w-80 bg-primaryBgColor max-w-image ${topMargin} ${message.position === 'right' && 'bg-primaryColor'}`}
				onMouseEnter={() => { setIsHover(true) }} onMouseLeave={() => { setIsHover(false) }}>
				{(message?._parent ?
					<ParentChatMessage
						backgroundColor={message.position === 'right' ? adjustHexColor(design.themeColor, 10) : '#EBEDED'}
						parentMessage={message?._parent} messagePosition={message.position}
					/>
					: null
				)}
				{
					(message.medias && message.medias.length)
						?
						message.medias.map((media: any) => {
							return (
								<>
									<div key={ media.url + message.mid}>
										<span className="mb-4 ele-image-message-label">{media.caption}</span>
										<img className="rounded-lg ele-image-src" src={media.url} alt="" />
									</div>
								</>
							)
						})
						:
						<>
							<span className="mb-4 ele-image-message-label prose" dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
							<img className="rounded-lg ele-image-src" src={message.source} alt="" />
						</>
				}
				<MessageActions message={message} show={isHover} />
			</div>
		</>
	);
}
